import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns";
import { useEffect, useState } from "react";
import { apiPostWToken } from "../../api/apiPost";
import { useConf } from "../../context/account/paramsAccount";
import { Button } from "@progress/kendo-react-buttons";
import { saveCredentials } from "../../functions/localStorage/saveLocalStorage";
import { useError } from "../../context/erreur/erreurContext";

const columns = [
    // { field: "soc_id", header: "Société id", width: "10%" },
    { field: "soc_nom", header: "Nom de la société", width: "30%" },
    // { field: "sit_id", header: "id sit", width: "10%" },
    { field: "sit_nom", header: "Nom site", width: "30%" },
];

export function Reglages() {
    const { conf, setConf }: any = useConf()
    const { showError } = useError();
    const [dataTab, setDataTab] = useState([])
    const [site, setSite] = useState({
        sit_couleur: null,
        sit_id: 0,
        sit_nom: "",
        soc_id: 0,
        soc_nom: "",
        v_ordre: "",
    })
    const data = null
    useEffect(() => {
        if (conf.token !== '' && conf.token !== undefined) {
            apiPostWToken("/posts/choix-site", data, conf.token, conf, setConf, showError).then((response: any) => {
                setDataTab(response)
            })
        }
    }, [])
    const onSubmit = (props: any) => {
        const updatedSite = props.value;

        // Mettre à jour uniquement le champ `site` dans `user`
        const updatedUser = {
            ...conf.user, // Conserver toutes les autres propriétés de `user`
            site: updatedSite, // Mettre à jour uniquement `site`
        };

        // Nouvelle configuration avec l'utilisateur mis à jour
        const newData = {
            ...conf, // Conserver les autres parties de `conf`
            user: updatedUser, // Inclure `user` mis à jour
        };

        // Mettre à jour l'état React
        setConf(newData);

        // Sauvegarder dans le localStorage
        saveCredentials(
            newData, // La configuration mise à jour
            conf,    // Ancienne configuration
            setConf,
            conf.user.user_code
        );
    }
    const saveId = () => {
        if (site.sit_nom !== "") {
            const newData = {
                user: { ...conf.user, site: site },
                token: conf.token,
                conf: { ...conf.conf }
            };
            setConf(newData)
            saveCredentials(newData,
                conf,
                setConf,
                conf.user.user_code);
        }
    }
    return <div className="reglages">
        <div className="societe">
            {
                conf?.conf?.authenticated ?
                    <div>
                        <h2>Utilisateur :</h2>
                        <p>{conf?.conf?.authenticated?.u_nom}</p>
                    </div>
                    : ""
            }
            <div>
                <h2>Choix du site :  </h2>
                <MultiColumnComboBox
                    data={dataTab}
                    columns={columns}
                    textField={"sit_nom"}
                    placeholder={conf?.user?.site?.sit_nom ? conf.user?.site?.sit_nom : "Selectionnez une valeur"}
                    onChange={onSubmit}
                />
                <Button onClick={saveId}>Enregistrer</Button>
            </div>
        </div>
    </div>
}